import { CheckIcon } from "@minervaproject/fds";
import clsx from "clsx";
import { useCallback, useContext } from "react";

import { MenuContext } from "contexts/menu";

function MenuItem({
  href,
  onClick,
  target,
  text,
  isMobile,
  isSelected,
  padUnselected,
}: {
  href?: string;
  onClick?: () => void;
  target?: string;
  text: string;
  isMobile?: boolean;
  isSelected?: boolean;
  padUnselected?: boolean;
}) {
  const { closeMenu } = useContext(MenuContext);
  const handleClick = useCallback(() => {
    onClick?.();
    closeMenu();
  }, [onClick, closeMenu]);
  const dataTestId = `menu-item-${text.toLowerCase().replaceAll(" ", "-")}`;

  return (
    <div
      className={clsx("menu-item flex items-center cursor-pointer", {
        ml4: padUnselected && !isSelected,
      })}
    >
      {href ? (
        <a
          className={clsx(
            "text-decoration-none text-black-tint-40 w-full",
            isMobile ? "px6 mx2 py2" : "px5",
            {
              body: isMobile,
            },
          )}
          href={href}
          target={target}
          data-testid={dataTestId}
        >
          {isSelected && <CheckIcon className="mr1" color="blackTint40" />}
          {text}
        </a>
      ) : (
        <button
          type="button"
          className={clsx(
            "button-reset cursor-pointer left-align text-black-tint-40 w-full",
            isMobile ? "px6 mx2 py2" : "px5",
            {
              body: isMobile,
            },
          )}
          onClick={handleClick}
          data-testid={dataTestId}
        >
          {isSelected && <CheckIcon className="mr1" color="blackTint40" />}
          {text}
        </button>
      )}
    </div>
  );
}

function MenuItemHeader({ text }: { text: string }) {
  return (
    <li
      className="flex items-center px5 py2 text-black-tint-70 body-xs"
      style={{ textTransform: "uppercase" }}
    >
      {text}
    </li>
  );
}

export { MenuItem, MenuItemHeader };
